/**
 * A dynamic heading component that renders h1, h2, or h3 with bold styling.
 *
 * @param {object} props
 * @param {1|2|3} [props.level=1] - Heading level to render (1 → h1, 2 → h2, 3 → h3).
 * @param {string} [props.className=''] - Additional CSS classes to append.
 * @param {React.ReactNode} props.children - Heading content.
 */
import PropTypes from "prop-types";
import styles from "./Heading.module.css";

const HEADING_TAGS = { 1: "h1", 2: "h2", 3: "h3" };

const Heading = ({ level = 1, className = "", children }) => {
  const Tag = HEADING_TAGS[level] ?? "h1";
  const levelClass = styles[`heading-${level}`];

  return (
    <Tag className={`${styles.heading} ${levelClass} ${className}`.trim()}>
      {children}
    </Tag>
  );
};

Heading.propTypes = {
  level: PropTypes.oneOf([1, 2, 3]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Heading;
